import { FC } from 'react';

interface InfoOutlineIconProps {
  color?: string;
  ariaName?: string;
}

export const InfoOutlineIcon: FC<InfoOutlineIconProps> = ({ color = '#767676', ariaName }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>{ariaName}</title>
      <g clipPath="url(#clip0_4056_62526)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.75 8C1.75 4.54822 4.54822 1.75 8 1.75C11.4518 1.75 14.25 4.54822 14.25 8C14.25 11.4518 11.4518 14.25 8 14.25C4.54822 14.25 1.75 11.4518 1.75 8ZM8 0.25C3.71979 0.25 0.25 3.71979 0.25 8C0.25 12.2802 3.71979 15.75 8 15.75C12.2802 15.75 15.75 12.2802 15.75 8C15.75 3.71979 12.2802 0.25 8 0.25ZM7.25 5.5V4L8.75 4V5.5H7.25ZM7.25 12V7H8.75V12H7.25Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_4056_62526">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
